import script from "./DashboardPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardPanel.vue?vue&type=script&setup=true&lang=js"

import "./DashboardPanel.vue?vue&type=style&index=0&id=4349d816&lang=scss"

const __exports__ = script;

export default __exports__